import cloneDeep from "lodash-es/cloneDeep"

import { createResponseTransformer } from "shared/api/createResponseTransformer"
import { serializer } from "shared/api/serializer/serializer"
import { transformJsonApiResponse } from "shared/api/transformJsonApiResponse"

import { ClarificationRequestsAPIType } from "../types/ClarificationRequest"

export const clarificationRequestResponseTransformer =
  createResponseTransformer(json => {
    return cloneDeep(
      serializer.deserialize(
        ClarificationRequestsAPIType,
        transformJsonApiResponse(json)
      )
    )
  })
